import { ADD_UPSERT_ENTITIES } from "./actionTypes";

export const addUpsertEntities = (payload) => ({ type: ADD_UPSERT_ENTITIES, payload });
